var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.estado,
                          expression: "form.estado"
                        }
                      ],
                      attrs: { name: "estado", id: "estado" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "estado",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "T" } }, [
                        _vm._v("Todas")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "I" } }, [
                        _vm._v("Incobrables")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "P" } }, [
                        _vm._v("Pendientes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "S" } }, [
                        _vm._v("En supervisión")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "A" } }, [
                        _vm._v("Anuladas")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "F" } }, [
                        _vm._v("Canceladas")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "estado" } }, [_vm._v("Estado")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        placeholder: "Escriba un número de documento...",
                        id: "numero_documento",
                        name: "numero_documento"
                      },
                      model: {
                        value: _vm.form.numero_documento,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "numero_documento", $$v)
                        },
                        expression: "form.numero_documento"
                      }
                    },
                    [_vm._v("\n              # Cartilla\n            ")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_fecha,
                          expression: "form.tipo_fecha"
                        }
                      ],
                      attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "tipo_fecha",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "T" } }, [
                        _vm._v("A la fecha")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "P" } }, [
                        _vm._v("Personalizada")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "tipo_fecha" } }, [
                    _vm._v("Tipo de fecha")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "desde",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "hasta",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "supervisor_id",
                          options: _vm.supervisores,
                          label: "nombre"
                        },
                        on: {
                          input: _vm.inputSupervisor,
                          search: _vm.searchSupervisores
                        },
                        model: {
                          value: _vm.selectedSupervisor,
                          callback: function($$v) {
                            _vm.selectedSupervisor = $$v
                          },
                          expression: "selectedSupervisor"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "supervisor_id" } }, [
                        _vm._v("Supervisor")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "recaudador_id",
                          options: _vm.recaudadores,
                          label: "nombre"
                        },
                        on: {
                          search: _vm.searchRecaudadores,
                          input: _vm.inputRecaudador
                        },
                        model: {
                          value: _vm.selectedRecaudador,
                          callback: function($$v) {
                            _vm.selectedRecaudador = $$v
                          },
                          expression: "selectedRecaudador"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "recaudador_id" } }, [
                        _vm._v("Recaudador")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.dia_cobro,
                          expression: "form.dia_cobro"
                        }
                      ],
                      attrs: { id: "dia_cobro" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "dia_cobro",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [_vm._v("Todos")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Lunes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2" } }, [
                        _vm._v("Martes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "3" } }, [
                        _vm._v("Miércoles")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "4" } }, [
                        _vm._v("Jueves")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "5" } }, [
                        _vm._v("Viernes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "6" } }, [
                        _vm._v("Sábado")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "7" } }, [
                        _vm._v("Domingo")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "dia_cobro" } }, [
                    _vm._v("Día de cobro")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "col-xs-12 col-md-8"
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "cliente",
                          options: _vm.clientes,
                          label: "nombre"
                        },
                        on: {
                          search: _vm.searchCliente,
                          input: _vm.inputCliente
                        },
                        model: {
                          value: _vm.selectedCliente,
                          callback: function($$v) {
                            _vm.selectedCliente = $$v
                          },
                          expression: "selectedCliente"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "cliente" } }, [
                        _vm._v("Cliente")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-field select2 select2-field--stretch" },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.bodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione...",
                          id: "ruta_id",
                          options: _vm.rutas,
                          label: "descripcion"
                        },
                        on: { search: _vm.onSearchRuta, input: _vm.inputRuta },
                        model: {
                          value: _vm.selectedRuta,
                          callback: function($$v) {
                            _vm.selectedRuta = $$v
                          },
                          expression: "selectedRuta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "ruta_id" } }, [
                        _vm._v("Ruta")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("p", [
                _c("label", { attrs: { for: "devoluciones" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.devoluciones,
                        expression: "form.devoluciones"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "devoluciones",
                      id: "devoluciones"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.devoluciones)
                        ? _vm._i(_vm.form.devoluciones, null) > -1
                        : _vm.form.devoluciones
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.form.devoluciones,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "devoluciones",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "devoluciones",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "devoluciones", $$c)
                        }
                      }
                    }
                  }),
                  _c("span", [_vm._v("Con devoluciones")])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-2" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _vm._m(3),
            _vm._v(" "),
            _c("k-table", {
              ref: "listaPedidos",
              attrs: {
                columns: [
                  {
                    display: "Ruta",
                    value: "ruta.descripcion"
                  },
                  {
                    display: "# Cartilla",
                    value: "numero_documento"
                  },
                  {
                    display: "Fecha",
                    value: "fecha"
                  },
                  {
                    display: "Cliente",
                    value: "nombre_cliente"
                  },
                  {
                    display: "Supervisor",
                    value: "nombre_supervisor"
                  },
                  {
                    display: "Recaudador",
                    value: "nombre_recaudador"
                  },
                  {
                    display: "Vendedor",
                    value: "descripcion_vendedor"
                  },
                  {
                    display: "Sucursal",
                    value: "descripcion_bodega"
                  },
                  {
                    display: "Día de cobro",
                    value: "descripcion_dia_cobro"
                  },
                  {
                    display: "Venta total",
                    value: "venta_total"
                  },
                  {
                    display: "Saldo",
                    value: "saldo_total"
                  },
                  {
                    display: "Saldo incobrable",
                    value: "saldo_incobrable"
                  },
                  {
                    display: "Estado",
                    value: "descripcion_estado"
                  },
                  {
                    display: "Estado de Pago",
                    value: "descripcion_estado_pago"
                  },
                  {
                    display: "Observación",
                    value: "observacion"
                  },
                  {
                    display: "Solicitud de anulación",
                    value: "solicitud_anulacion"
                  }
                ],
                buttons:
                  _vm.cliente == null
                    ? [
                        {
                          event: "verVisita",
                          icon: "fa-table",
                          class: "btn-info btn--text",
                          text: "Visita"
                        },
                        {
                          event: "verPedido",
                          class: "btn-success btn--text",
                          icon: "fa-edit"
                        }
                      ]
                    : [
                        {
                          event: "verPedido",
                          class: "btn-success btn--text",
                          icon: "fa-eye"
                        }
                      ],
                estadoAutorizado: "F",
                estadoCancelado: "A",
                path: _vm.path,
                buscarButton: false,
                createButton: false,
                editButton: false,
                deleteButton: _vm.puedeAnularPedido,
                filterStatus: false,
                params: _vm.form,
                soloAnulacion: ""
              },
              on: {
                verVisita: _vm.verVisita,
                verPedido: _vm.verPedido,
                eliminar: _vm.eliminar
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "informacionPedido",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "65%",
            clickToClose: false
          }
        },
        [
          _c("informacion-pedido", {
            attrs: {
              cliente: _vm.cliente,
              puedeRegistrarAbonos: _vm.puedeRegistrarAbonos,
              puedeEditarAbonos: _vm.puedeEditarAbonos,
              puedeAnularAbonos: _vm.puedeAnularAbonos,
              puedeEditarPedido: _vm.puedeEditarPedido,
              pedidoId: _vm.currentPedidoId
            },
            on: {
              actualizado: _vm.pedidoActualizado,
              cerrar: function($event) {
                return _vm.$modal.hide("informacionPedido")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "ven" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Ventas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c("span", { staticClass: "dot tr--authorized" }),
          _vm._v(" "),
          _c("label", [_vm._v("Canceladas")]),
          _vm._v(" "),
          _c("span", { staticClass: "dot tr--issued" }),
          _vm._v(" "),
          _c("label", [_vm._v("Con abonos de entrada")]),
          _vm._v(" "),
          _c("span", { staticClass: "dot tr--pending" }),
          _vm._v(" "),
          _c("label", [_vm._v("Con ítems pendientes")]),
          _vm._v(" "),
          _c("span", { staticClass: "dot tr--canceled" }),
          _vm._v(" "),
          _c("label", [_vm._v("Anuladas")])
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37d06851", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d06851","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ListaPedidos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-37d06851","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ListaPedidos.vue
// module chunks = 0